import styled from 'styled-components';

const ContenedorError = styled.div`
    max-width: 450px;
    margin: 0 auto;
    margin-top: 35px;
    margin-bottom: 55px;
    padding: 15px;
    
    .error-info img {
        filter: none;
    }

    h2{
        font-size:18px;
        color: #383838;
        font-weight: bold;
    }
    .error-info {
        margin: 0 auto;
        text-align: center;
    }
    .error-info img {
        margin: 20px auto;
    }

    .CardBase > header {
        padding: 17px 32px;
    }
    .error-info h2 {
        font-size: 24px;
    }

    .error-info p {
        color: #252525;
        font-size: 16px;
        font-weight: 400;
        padding-bottom: 46px;
    }
    .error-info button {
        margin-bottom: 26px;
    }

    .Button--secondary {
        color: #EC1B2B;
        font-weight: 500;
        border: 0;
        text-decoration: underline;
    }
    .Button--secondary:hover{
        color: #EC1B2B;
        background: none !important;
    }
    .Button--primary:hover:enabled {
        background-color: none;
    }
    .Button--primary:hover:enabled {
        background-color: #f42534;
    }

    @media (max-width: 426px){
        h2 {
          font-size: 20px;
        }
      .error-info img {
            margin: 20px auto;
            width: 140px;
          }
          .error-info h2 {
            font-size: 22px;
          }
          .error-info p {
            font-size: 14px;
          }
         .Button {
          padding: 10px 49px;
          font-size: 13px;
         }
    }


    @media (max-width: 376px){
        h2 {
            font-size: 16px;
        }
      .error-info img {
            margin: 20px auto;
            width: 140px;
          }
          .error-info h2 {
            font-size: 21px;
          }
          .error-info p {
            font-size: 14px;
          }
         .Button {
          padding: 10px 33px;
          font-size: 14px;
         }
    }

    @media (max-width: 321px){
        h2 {
            font-size: 16px;
        }
      .error-info img {
            margin: 20px auto;
            width: 120px;
          }
          .error-info h2 {
            font-size: 21px;
          }
          .error-info p {
            font-size: 14px;
          }
         .Button {
          padding: 10px 33px;
          font-size: 14px;
         }
    }
`;

export default ContenedorError;